// extracted by mini-css-extract-plugin
export default {"grid":"xmlMappingElements_grid__Hsznw"};